class TokenService {

    constructor($window, $cookies, tokenCookieName, $cacheFactory, initConfigProvider) {
        this.window = $window;
        this.cookies = $cookies;
        this.tokenCookieName = tokenCookieName;
        this.ssoCookieName = initConfigProvider.ssoCookieName;
        this.cache = $cacheFactory("tokenCache");
        this.configProvider = initConfigProvider;
        this.tokenObjectCacheName = "tokenObject";
    }

    setAutheticatedUserToken(token) {
        let payload = this._parseJwtPayload(token);
        this.cache.put(this.tokenObjectCacheName, payload);
        let cookieExpiryDate = new Date(payload.exp * 1000);
        this.cookies.put(this.tokenCookieName, token, {'expires': cookieExpiryDate});
    }
    
    hasToken() {
        return this.cookies.get(this.tokenCookieName) !== undefined;
    }

    hasSSOToken() {
        return this.cookies.get(this.ssoCookieName) !== undefined;
    }
    
    getAutheticatedUserToken() {
        return this.cookies.get(this.tokenCookieName);
    }

    getSSOToken() {
        return this.cookies.get(this.ssoCookieName);
    }

    getAutheticatedUserTokenPayload() {
        return this._getPayload();
    }
    
    clearAutheticatedUserToken() {
        this.cookies.remove(this.tokenCookieName);
        this.cache.removeAll();
    }

    _getPayload() {
        let payload = this.cache.get(this.tokenObjectCacheName);
        if (!payload) {
            let token = this.cookies.get(this.tokenCookieName);
            if (token) {
                let payload = this._parseJwtPayload(token);
                this.cache.put(this.tokenObjectCacheName, payload);
                return payload;
            }
            return undefined;
        }
        return payload;
    }
    
    _parseJwtPayload(token) {
        let base64Url = token.split('.')[1];
        let base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(this.window.atob(base64));
    }

    static tokenServiceFactory($window, $cookies, ipCookie, $cacheFactory, initConfigProvider){
        return new TokenService($window, $cookies, ipCookie, $cacheFactory, initConfigProvider);
    }
}

TokenService.tokenServiceFactory.$inject = ['$window', '$cookies', 'USER_TOKEN_COOKIE_NAME', '$cacheFactory', 'initConfigProvider'];

export default TokenService;



// WEBPACK FOOTER //
// ./app/services/token.service.js